"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonConfigResponseT = exports.SkeletonConfigResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const skeleton_part_js_1 = require("../../solarxr-protocol/rpc/skeleton-part.js");
class SkeletonConfigResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSkeletonConfigResponse(bb, obj) {
        return (obj || new SkeletonConfigResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSkeletonConfigResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new SkeletonConfigResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    skeletonParts(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new skeleton_part_js_1.SkeletonPart()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    skeletonPartsLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    userHeight() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    static startSkeletonConfigResponse(builder) {
        builder.startObject(2);
    }
    static addSkeletonParts(builder, skeletonPartsOffset) {
        builder.addFieldOffset(0, skeletonPartsOffset, 0);
    }
    static createSkeletonPartsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startSkeletonPartsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addUserHeight(builder, userHeight) {
        builder.addFieldFloat32(1, userHeight, 0.0);
    }
    static endSkeletonConfigResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSkeletonConfigResponse(builder, skeletonPartsOffset, userHeight) {
        SkeletonConfigResponse.startSkeletonConfigResponse(builder);
        SkeletonConfigResponse.addSkeletonParts(builder, skeletonPartsOffset);
        SkeletonConfigResponse.addUserHeight(builder, userHeight);
        return SkeletonConfigResponse.endSkeletonConfigResponse(builder);
    }
    unpack() {
        return new SkeletonConfigResponseT(this.bb.createObjList(this.skeletonParts.bind(this), this.skeletonPartsLength()), this.userHeight());
    }
    unpackTo(_o) {
        _o.skeletonParts = this.bb.createObjList(this.skeletonParts.bind(this), this.skeletonPartsLength());
        _o.userHeight = this.userHeight();
    }
}
exports.SkeletonConfigResponse = SkeletonConfigResponse;
class SkeletonConfigResponseT {
    constructor(skeletonParts = [], userHeight = 0.0) {
        this.skeletonParts = skeletonParts;
        this.userHeight = userHeight;
    }
    pack(builder) {
        const skeletonParts = SkeletonConfigResponse.createSkeletonPartsVector(builder, builder.createObjectOffsetList(this.skeletonParts));
        return SkeletonConfigResponse.createSkeletonConfigResponse(builder, skeletonParts, this.userHeight);
    }
}
exports.SkeletonConfigResponseT = SkeletonConfigResponseT;
